export const stringMapDefault = {
    characterCount: "{characterCount} of {maxLength} characters",
    maxLength: "Limited to {maxLength} characters."
};
